import { FC, ReactNode, MouseEventHandler } from 'react';
import { graphql, useFragment } from 'react-relay';

import { Button } from 'dibs-elements/exports/Button';
import { useAddItemToCart } from 'dibs-buyer-layout/exports/useAddItemToCart';

import { PdpSharedShoppingButton_user$key } from './__generated__/PdpSharedShoppingButton_user.graphql';
import { PdpSharedShoppingButton_item$key } from './__generated__/PdpSharedShoppingButton_item.graphql';

const userFragment = graphql`
    fragment PdpSharedShoppingButton_user on User {
        ...useAddItemToCart_user
    }
`;
const itemFragment = graphql`
    fragment PdpSharedShoppingButton_item on Item {
        ...useAddItemToCart_item
    }
`;

export const PdpSharedShoppingButton: FC<{
    user: PdpSharedShoppingButton_user$key | null;
    item: PdpSharedShoppingButton_item$key;
    skuId?: string;
    quantitySelected?: string;
    type?: 'primary' | 'secondary';
    onClick: MouseEventHandler;
    children: ReactNode;
    disabled?: boolean;
    isMultiItemCart?: boolean;
}> = ({
    user: userRef,
    item: itemRef,
    skuId,
    quantitySelected,
    type = 'primary',
    onClick,
    children,
    disabled,
}) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const { addItemToCart, isAddingItemToCart } = useAddItemToCart({
        user,
        item,
        quantitySelected: parseInt(quantitySelected || '', 10) || 1,
        skuId: skuId || null,
        onClick,
    });

    return (
        <Button
            fullWidth
            type={type}
            size="large"
            onClick={e => addItemToCart(e)}
            disabled={isAddingItemToCart || disabled}
        >
            {children}
        </Button>
    );
};
